import React, { useState } from "react";

const UnhealthyScroll = () => {
  const [activeQuestion, setActiveQuestion] = useState(1);

  const toggleQuestion = (questionNumber) => {
    setActiveQuestion((prev) => (prev === questionNumber ? null : questionNumber));
  };

  return (
    <div className="col-xl-7 d-flex align-items-center justify-content-center">
      <div>
        {/* Question 1 */}
        <div className="line-card-one">
          <div
            className={`question ${activeQuestion === 1 ? "colo-active-obesity" : ""}`}
            onClick={() => toggleQuestion(1)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              cursor: "pointer",
              alignItems: "center",
              transition: "color 0.3s ease",
            }}
          >
            <span className="font-smd">Skipping breakfast or major meal</span>
            <i
              className="fas fa-chevron-down font-smd"
              style={{
                transform: activeQuestion === 1 ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.4s ease",
              }}
            ></i>
          </div>
          <div
            className="answer font-xsm"
            style={{
              maxHeight: activeQuestion === 1 ? "600px" : "0",
              overflow: "hidden",
              transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
            }}
          >
            <p className="font-xsm justify_content">
              Research highlights the association between skipping breakfast and increased risk
              of being overweight and obese. Hence, daily breakfast consumption may decrease
              the risk of adverse effects related to glucose and insulin metabolism and can be
              helpful in promoting healthy dietary habits throughout the day.
            </p>
            <div className="font-xsm mb-1 fw-semibold color-blue-abdominal">
              Avoid skipping breakfast or any major meal!!
            </div>
          </div>
        </div>

        {/* Question 2 */}
        <div className="line-card-one">
          <div
            className={`question ${activeQuestion === 2 ? "colo-active-obesity" : ""}`}
            onClick={() => toggleQuestion(2)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              cursor: "pointer",
              alignItems: "center",
              transition: "color 0.3s ease",
            }}
          >
            <span className="font-smd">
              Irregular meal timings & inadequate meal frequencies
            </span>
            <i
              className="fas fa-chevron-down font-smd"
              style={{
                transform: activeQuestion === 2 ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.4s ease",
              }}
            ></i>
          </div>
          <div
            className="answer"
            style={{
              maxHeight: activeQuestion === 2 ? "600px" : "0",
              overflow: "hidden",
              transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
            }}
          >
            <p className="font-xsm justify_content">
              Increasing meal frequency may reduce cholesterol levels. The increased meal
              frequency pattern may be more effective at lowering total and LDL (bad)
              cholesterol. It also has significant positive impact on increasing HDL (good) and
              lowering Triglycerides. Hence, current research indicates that around 4 meals per
              day would be healthy.
            </p>
          </div>
        </div>

        {/* Question 3 */}
        <div className="line-card-one">
          <div
            className={`question ${activeQuestion === 3 ? "colo-active-obesity" : ""}`}
            onClick={() => toggleQuestion(3)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              cursor: "pointer",
              alignItems: "center",
              transition: "color 0.3s ease",
            }}
          >
            <span className="font-smd">Late and/or heavy dinner and health</span>
            <i
              className="fas fa-chevron-down font-smd"
              style={{
                transform: activeQuestion === 3 ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.4s ease",
              }}
            ></i>
          </div>
          <div
            className="answer"
            style={{
              maxHeight: activeQuestion === 3 ? "600px" : "0",
              overflow: "hidden",
              transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
            }}
          >
            <p className="font-xsm justify_content">
              Late dinner (within 4 hours of sleep time) increases nighttime sugar and lipid
              spikes. Late dinner followed by lack of activity during sleep hours leads to
              abnormal sugar, lipid profiles, insulin resistance and increased chances of having
              abdominal fat, being overweight or obese, and developing diabetes or high blood
              pressure.
            </p>
            <div className="font-xsm mb-1 fw-semibold color-blue-abdominal">
              Avoid nighttime carbohydrates loading!!
            </div>
          </div>
        </div>

        {/* Question 4 */}
        <div className="line-card-one">
          <div
            className={`question ${activeQuestion === 4 ? "colo-active-obesity" : ""}`}
            onClick={() => toggleQuestion(4)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              cursor: "pointer",
              alignItems: "center",
              transition: "color 0.3s ease",
            }}
          >
            <span className="font-smd">Lack of food diversity </span>
            <i
              className="fas fa-chevron-down font-smd"
              style={{
                transform: activeQuestion === 4 ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.4s ease",
              }}
            ></i>
          </div>
          <div
            className="answer"
            style={{
              maxHeight: activeQuestion === 4 ? "600px" : "0",
              overflow: "hidden",
              transition: "max-height 0.8s cubic-bezier(0.25, 0.8, 0.25, 1)",
            }}
          >
            
            <div className="font-md">
                            <div className="custom-list-effectonhealth mb-2  text-muted ">

                              <div className=" custom-list-item-height-two font-xsm">
                                <span className="me-2 bullet_point_black"> </span>
                                One should eat balanced diet.
                              </div>
                              <div className=" custom-list-item-height-two font-xsm justify_content">
                                <span className="me-2 bullet_point_black"> </span>
                                Eating too much of a single food group is unhealthy. Indian Council of Medical Research (ICMR) recommends 130g / day of carbohydrates per day
                              </div>
                              <div className=" custom-list-item-height-two font-xsm ">
                                <span className="me-2 bullet_point_black"> </span>
                                However, urban Indians are eating 289 g carbohydrates while in rural India, an average adult consumes 368 g of carbohydrates. This is far above the recommended amount. This could be the underlying cause of high insulin resistance and obesity among Indians.
                              </div>


                              <div className="font-xsm fw-semibold color-blue-abdominal justify_content">
                                Too much of carbohydrate intake may lead to hyper insulin state and insulin resistance. This is the foundation for weight gain and abdominal obesity.
                              </div>










                            </div>
                          </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default UnhealthyScroll;
